const requestSampleDataType = 'REQUEST_TEST_Logs_SampleData';
const receiveSampleDataType = 'RECEIVE_TEST_Logs_SampleData';
const requestCaseTypesReport = 'REQUEST_TEST_CaseTypesReport';
const receiveCaseTypesReport = 'RECEIVE_TEST_CaseTypesReport';
const initialState = { testLogsSampleData: [], caseTypesReportData: [],  isLoading: false, isLoadingCaseTypesData: false };

export const actionCreators = {
    requestTestLogsSampleData: (testDefId, dbName, searchFrom, runDate, groupByFields) => async (dispatch, getState) =>
        new Promise(async function (resolve, reject) {
            if (getState().isLoading) {
                // Don't issue a duplicate request (already loading the requested data)
                return;
            }

            dispatch({ type: requestSampleDataType });
            const url = `api/ATekTestDataApi/GetSampleData?testId=${testDefId}&databaseName=${dbName}&searchFrom=${searchFrom}&runDate=${runDate}`;
            let fetchData = {
                method: 'POST',
                body: groupByFields,
                headers: new Headers({ 'content-type': 'application/json' })
            }
            const response = await fetch(url, fetchData);
            const testLogsSampleData = await response.json();

            dispatch({ type: receiveSampleDataType, testLogsSampleData });
            resolve(testLogsSampleData);
        }),

    requestCaseTypesReport: (ossId, searchStart, searchEnd) => async (dispatch, getState) =>
        {
            if (getState().isLoading) {
                // Don't issue a duplicate request (already loading the requested data)
                return;
            }

            if (!ossId)
                ossId = 45;

            dispatch({ type: requestCaseTypesReport });
            const url = `api/ATekTestDataApi/GetCaseTypesReport?ossId=${ossId}&searchStart=${searchStart}&searchEnd=${searchEnd}`;
            let fetchData = {
                method: 'GET',
                headers: new Headers({ 'content-type': 'application/json' })
            }

            await fetch(url, fetchData).then(
                response => response.json(),
                error => console.log('Error in requestCaseTypesReport', error)).then(
                    caseTypesReportData => dispatch({ type: receiveCaseTypesReport, caseTypesReportData })
            );
        }

};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestSampleDataType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveSampleDataType) {
        return {
            ...state,
            testLogsSampleData: action.testLogsSampleData,
            isLoading: false
        };
    }

    if (action.type === requestCaseTypesReport) {
        return {
            ...state,
            isLoading: true,
            isLoadingCaseTypesData: true
        };
    }

    if (action.type === receiveCaseTypesReport) {
        return {
            ...state,
            caseTypesReportData: action.caseTypesReportData,            
            isLoading: false,
            isLoadingCaseTypesData: false
        };
    }
    return state;
};
